import React from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridNoRecords
  } from "@progress/kendo-react-grid";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";

const ContractResources = (props: any) => {

  const navigate = useNavigate()

  const contractDurationCell = (duration: GridCellProps) => {
    
    return (
      <td>
        {duration && duration.dataItem.contractStartDate ? new Date(parseInt(duration.dataItem.contractStartDate)).toDateString().slice(3) + ' - ' : 'Not mentioned'} {(duration && duration.dataItem.contractEndDate && duration.dataItem.contractEndDate) ? duration.dataItem.contractEndDate && new Date(parseInt(duration.dataItem.contractEndDate)).toDateString().slice(3): duration.dataItem.contractEndDate ? 'In progress' : ''}
     </td>
   )
 }

 const redirection = (candidateLoginId: string) => {
  navigate('../preview', { state: { candidateLoginId: candidateLoginId}})
}

const contractSkillsCell = (skills: GridCellProps) => {
  let length = skills && skills.dataItem && skills.dataItem.skills && skills.dataItem.skills.length;
  
  return (
    <td>
        <div className="positionStstus">
          {skills && skills.dataItem && skills.dataItem.skills && skills.dataItem.skills.map((item: string, key: number)  => {
           return ((item) +  (key < length-1 ? ' , ' : ''))})}
        </div>
     </td>
    )
}
  
  return (
    <div className='tableStyle'>
    <Grid
         data={props.state.items}
         onPageChange={props.pageChange}
         total={props.state.total}
         skip={props.state.skip}
         pageable={props.state.pageable}
         pageSize={props.state.pageSize}
         onItemChange={props.itemChange}
    >
        <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
        <Column field="fullName" title="Name"  width="180" className="noWordWrap" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string) => redirection(candidateLoginId))}/>
        <Column title="Skills"  cell={contractSkillsCell}  />
        <Column field="jobTitle" title="Job Title" />
        <Column field="jobRole" title="Job Role" />
        <Column field="rate" title="Rate" />
        <Column field="ContractDuration" title="Contract Duration" cell={contractDurationCell} />
        <Column cell={ViewButton}  width="120px" />
    </Grid>  
</div>
  )
}

export default ContractResources

const nameCell = (props: GridCellProps, redirection: any) => {

  let currentDate = new Date().getTime()
  let dateOfRegistration = props.dataItem.createdDate
  var diff =(currentDate -  dateOfRegistration) / 1000
  diff /= (60 * 60);
  let diff2 = Math.abs(Math.round(diff))
  
  const profileImage = props.dataItem.image ?  props.dataItem.image : " " 
  return (
    <td className="statusWrap">
      {diff2 <= 24 &&
        <span className="userStatus">New</span>
      }
      <div className="userInfo" onClick={() => redirection(props.dataItem.candidateLoginId)}>
          {profileImage === " "? 
           <figure>{props.dataItem && props.dataItem.fullName && props.dataItem.fullName[0]}{props.dataItem && props.dataItem.fullName && props.dataItem.fullName[1]}</figure>
          :
          <figure><img src={ profileImage }></img></figure> 
          }
          <div>
          {props.dataItem.fullName}
          </div>
      </div>
    </td>
  )
}

const ViewButton = (props: GridCellProps) => {    
  
  const navigate = useNavigate()  
  return (
    <td>
      <button onClick={(e: any) => navigate('../timesheets', { state: { candidateJobId: props.dataItem.candidateJobId, jobTitle: props.dataItem.jobTitle, name: props.dataItem.fullName }})}
        className="applyButton">
          View Timesheet
      </button> 
  </td>
  );
}